import { defineStore } from 'pinia'
import ShowcaseService from '~/services/ShowcaseService';
import { usePublisherStore } from './PublisherModule';
import type { IShowCaseUpdateData } from '~/interfaces/publisher/showcase';
import { getUserId } from '~/common/helpers';

export const useMyPublisherShowcaseStore = defineStore('showcase', () => {
  const publisherStore = usePublisherStore();

  async function getShowCaseData() {
    const response = await ShowcaseService.getShowCaseData();
    return response;
  }

  async function getShowCaseDataPublic(url: string) {
    const response = await ShowcaseService.getShowCaseDataPublic(url);
    return response;
  }

  async function saveShowCase(data: IShowCaseUpdateData) {

    const saveData = {
      slug: data.slug,
      name: data.name,
      description: data.description,
      avatar: "https://data-light-stage-bucket.storage.yandexcloud.net/67ea75456fff6-pixel.png",
      cover: "https://data-light-stage-bucket.storage.yandexcloud.net/67ea75456fff6-pixel.png",
      channels: data.channels,
      isActive: data.isActive || true,
    }

    const response = await ShowcaseService.saveShowCase(saveData);
    return response;
  }

  return {
    getShowCaseData,
    getShowCaseDataPublic,
    saveShowCase,
  }
});
